export const name = 'rnLocaleOrderBy';

export default function rnLocaleOrderBy(rnFormat) {
  'ngInject';

  return rnFormat.localeOrderBy;
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/locale/format/locale-order-by.filter.js